import account from 'accounting'
import React from 'react'
import { Invoiceable } from './model'
// Settings object that controls default parameters for library methods:

account.settings = {
  currency: {
    symbol: '$', // default currency symbol is '$'
    format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
    decimal: '.', // decimal point separator
    thousand: ',', // thousands separator
    precision: 2, // decimal places
  },
  number: {
    precision: 0, // default precision on numbers is 0
    thousand: ',',
    decimal: '.',
  },
}

// These can be changed externally to edit the library's defaults:
account.settings.currency.format = '%s %v'

// Format can be an object, with `pos`, `neg` and `zero`:
account.settings.currency.format = {
  pos: '%s %v', // for positive values, eg. "$ 1.00" (required)
  neg: '%s -%v', // for negative values, eg. "$ (1.00)" [optional]
  zero: '%s --- ', // for zero values, eg. "$  --" [optional]
}

// Example using underscore.js - extend default settings (also works with $.extend in jQuery):
account.settings.number = { ...account.settings.number, precision: 2, thousand: ' ' }

export const formatMoney = (value: number, locale: string) => {
  switch (locale) {
    case 'en':
      return account.formatMoney(value)
    case 'en-CA':
      return account.formatMoney(value)
    case 'en-IE':
      return account.formatMoney(value, '€', 2, '.', ',')
    case 'en-GB':
      return account.formatMoney(value, '£', 2, '.', ',')
    case 'en-MT':
      return account.formatMoney(value, '€', 2, '.', ',')
    case 'es-MX':
      return account.formatMoney(value, '$', 2, '.', ',')
    default:
      return account.formatMoney(value)
  }
}

export const formatCents = (cents: number, locale = 'en'): string => (cents ? formatMoney(cents / 100, locale) : '')

export function InvoiceableLink(
  props: React.PropsWithChildren<{
    type: Invoiceable['billable_type']
    id: Invoiceable['billable_id']
  }>
): JSX.Element {
  const link = getInvoiceableLink(props.type, props.id)
  return link ? (
    <a href={link} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  ) : (
    <span>{props.children}</span>
  )
}

function getInvoiceableLink(type: Invoiceable['billable_type'], id: Invoiceable['billable_id']): string | null {
  switch (type) {
    case 'order':
      return `#/orders/${id}`
    case 'restaurant':
      return `${process.env.CHEF_URL}/#/onboarding/restaurant/${id}`
    default:
      return null
  }
}
